import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lifebenefits' })
export class LifeBenefitsPipe implements PipeTransform {
    transform(input: any, bu: any): any {
        if (!(input && bu)) {
            return [];
        }
        if (/Life Insurance/i.test(bu)) {
            let output = [];
            for (let i = 0; i < input.length; i++) {
                if ((/Benefit/i.test(input[i].title))) {
                    output.push(input[i]);
                }
            }
            return output;
        }
        return input;
    }
}

@Pipe({ name: 'Notlifebenefits' })
export class NotLifeBenefitsPipe implements PipeTransform {
    transform(input: any, bu: any): any {
        if (!(input && bu)) {
            return [];
        }
        if (/Life Insurance/i.test(bu)) {
            let output = [];
            for (let i = 0; i < input.length; i++) {
                if (!(/Benefit/i.test(input[i].title))) {
                    output.push(input[i]);
                }
            }
            return output;
        }
        return input;
    }
}